<!-- relation-pill.component.html -->
<span class="relation-pill">
  <span class="relation-label">{{ label }}</span>

  @if (hasProfileClick) {
    <!-- klickbar (PrimeNG Text-Link-Button) -->
    <p-button
      [label]="otherDisplay"
      link
      styleClass="m-0 p-0"
      (onClick)="$event.preventDefault();$event.stopPropagation();onClickOther()" />
  } @else {
    <!-- nur Text, kein Link -->
    <span class="relation-text">{{ otherDisplay }}</span>
  }
</span>
